import { createContext, useContext, useMemo, useRef, useState } from 'react';
import type { TableProperty } from '~/shared/models/device/BrokerValuesModel';

interface StreamDeviceContextType {
  liveModeEnabled: boolean;
  setLiveModeEnabled: (enabled: boolean) => void;
  initialBrokerValuesRef: React.RefObject<TableProperty[]>;
}

const StreamDeviceContext = createContext<StreamDeviceContextType | undefined>(
  undefined,
);

export function StreamDeviceProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [liveModeEnabled, setLiveModeEnabled] = useState(false);
  const initialBrokerValuesRef = useRef<TableProperty[]>([]);

  const contextValue = useMemo(
    () => ({ liveModeEnabled, setLiveModeEnabled, initialBrokerValuesRef }),
    [liveModeEnabled],
  );

  return (
    <StreamDeviceContext.Provider value={contextValue}>
      {children}
    </StreamDeviceContext.Provider>
  );
}

export function useStreamDeviceContext() {
  const context = useContext(StreamDeviceContext);
  if (!context) {
    throw new Error(
      'useStreamDeviceContext must be used inside a StreamDeviceProvider',
    );
  }
  return context;
}
